import React from 'react';

import { ListItem, Text } from '@change/ds-core-ui';
import {
	ChatBubbleIcon,
	DecisionMakerIcon,
	MediaIcon,
	PetitionIcon,
	SignaturesIcon,
	VictoryIcon,
} from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';
import { Link } from '@change-corgi/core/react/router';

import { useLearnHowSection } from './hooks/useLearnHowSection';

export const LearnHowSection: React.FC = () => {
	const {
		data: { coreArticles },
		actions: { trackArticleClick },
	} = useLearnHowSection();

	// These icons will map to the order of the articles
	const coreArticleIcons = [PetitionIcon, SignaturesIcon, ChatBubbleIcon, MediaIcon, DecisionMakerIcon, VictoryIcon];

	if (coreArticles.length === 0) {
		return null;
	}

	return (
		<div className="space-y-4">
			<Text size="small" variant="heading" fontWeight="light" className="pl-1.5">
				<Translate value="corgi.petition_guides_article.page_body.sidebar.learn_how_section.title" />:
			</Text>

			<div className="space-y-2">
				{coreArticles.map((article) => {
					const IconComponent = coreArticleIcons[coreArticles.indexOf(article)] ?? PetitionIcon;

					return (
						<ListItem
							as={Link}
							to={`/petition-guides/${encodeURIComponent(article.slug)}?source_location=${article.slug}-article`}
							key={article.slug}
							data-qa={`${article.slug}-sidebar-link`}
							className="py-2 no-underline"
							label={
								<Text size="x-small" variant="heading">
									{`${article.headingShort}`}
								</Text>
							}
							leadingSlot={
								<div className="flex items-center justify-center rounded-md bg-surface-tertiary p-2">
									<IconComponent />
								</div>
							}
							forceInteractive
							onClick={trackArticleClick}
						/>
					);
				})}
			</div>
		</div>
	);
};
